import { render, staticRenderFns } from "./WalletBalances.vue?vue&type=template&id=07693a8d&"
import script from "./WalletBalances.vue?vue&type=script&lang=js&"
export * from "./WalletBalances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports